// extracted by mini-css-extract-plugin
export var avatarContainer = "_o-0";
export var avatarTypingWave = "_o-i";
export var gray = "_o-f";
export var green = "_o-c";
export var icon = "_o-9";
export var image = "_o-1";
export var lg = "_o-6";
export var md = "_o-5";
export var presenceDot = "_o-b";
export var red = "_o-d";
export var sm = "_o-4";
export var status = "_o-a";
export var typingDot = "_o-h";
export var typingPill = "_o-g";
export var xl = "_o-7";
export var xs = "_o-3";
export var xxl = "_o-8";
export var xxs = "_o-2";
export var yellow = "_o-e";